import type { FC } from 'react';

import { Breadcrumbs, Link, useDeviceType } from '@packages/shared';

import type { Breadcrumb, BreadcrumbSchema } from '../../api/rest/types';

export type ProductListBreadcrumbsProps = {
  breadcrumbs: Breadcrumb[];
  breadCrumbSchema: BreadcrumbSchema[];
  resultCount: number;
};

/**
 * ProductListBreadcrumbs component to render the breadcrumbs for the product list. Items on mobile are limited to 3 and the rest is
 * accessible via dots click which expands the rest. Used separator is a slash icon (default).
 * */
export const ProductListBreadcrumbs: FC<ProductListBreadcrumbsProps> = ({
  breadcrumbs,
  breadCrumbSchema,
  resultCount,
}) => {
  const { isMobile } = useDeviceType();

  return (
    <>
      <Breadcrumbs
        data-testid="product-list-breadcrumbs"
        itemsAfterCollapse={isMobile ? 2 : undefined}
      >
        {breadcrumbs.map((breadcrumb, index) =>
          breadcrumb.uriPath ? (
            <Link key={breadcrumb.id} href={breadcrumb.uriPath} underline="hover" color="inherit">
              {breadcrumb.name}
            </Link>
          ) : (
            <span key={breadcrumb.id}>
              <span>{breadcrumb.name}</span>
              {/* Only in case it's the last element the count should be rendered */}
              {index === breadcrumbs.length - 1 && ` (${resultCount})`}
            </span>
          ),
        )}
      </Breadcrumbs>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadCrumbSchema),
        }}
      />
    </>
  );
};
